import ExpandColumn from "./ExpandColumn";
import ProductosSubTabla from "./ProductosSubTabla";

export { ProductosSubTabla, ExpandColumn };
